import { jsx as _jsx } from "react/jsx-runtime";
import CertificateButtonCompleted from './CertificateButtonCompleted';
import CertificateButtonExpired from './CertificateButtonExpired';
import CertificateButtonWrapper from './CertificateButtonWrapper';

const CertificateButton = ({
  isCompleted,
  isExpired,
  isSelected,
  expiresAt,
  awardName,
  name,
  onClick,
  trackId
}) => {
  if (isExpired) {
    return /*#__PURE__*/_jsx(CertificateButtonExpired, {
      expiresAt: expiresAt,
      isSelected: isSelected,
      name: name,
      onClick: onClick
    });
  }

  if (isCompleted) {
    return /*#__PURE__*/_jsx(CertificateButtonCompleted, {
      awardName: awardName,
      expiresAt: expiresAt,
      isSelected: isSelected,
      name: name,
      onClick: onClick,
      trackId: trackId
    });
  }

  return /*#__PURE__*/_jsx(CertificateButtonWrapper, {
    isSelected: isSelected,
    onClick: onClick,
    children: name
  });
};

export default CertificateButton;